import { render, staticRenderFns } from "./Propriedades.vue?vue&type=template&id=4e059d2e&scoped=true&"
import script from "./Propriedades.vue?vue&type=script&lang=js&"
export * from "./Propriedades.vue?vue&type=script&lang=js&"
import style0 from "./Propriedades.vue?vue&type=style&index=0&id=4e059d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e059d2e",
  null
  
)

export default component.exports